import { securityAuthenticationChangeEmailAsyncSlice } from './patch';

export const {
	requestPatchSecurityAuthenticationChangeEmail,
	resetPatchSecurityAuthenticationChangeEmail
} = securityAuthenticationChangeEmailAsyncSlice.asyncActionCreators;
